import React from 'react';
import { useLocalization } from '../../hooks/useLocalization/useLocalization.js';
import { Head } from '../../foundation/Head/Head.client.js';
export function NoIndexPageSeo({ title, titleTemplate, lang, }) {
    const { language: { isoCode: fallBacklang }, } = useLocalization();
    return (React.createElement(React.Fragment, null,
        React.createElement(Head, { defaultTitle: title ?? '', titleTemplate: titleTemplate ?? `%s - ${title}` },
            React.createElement("html", { lang: lang ?? fallBacklang }),
            React.createElement("meta", { name: "robots", content: "noindex" }))));
}
